import { render, staticRenderFns } from "./Simpler.vue?vue&type=template&id=36bb3518&lang=pug&"
import script from "./Simpler.vue?vue&type=script&lang=js&"
export * from "./Simpler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports